import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { RideArea } from '@polaris-customerweb/sharedcomponents.map';
import { find } from 'lodash-es';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import {
    SetRideAreas,
    UpdateRideArea,
} from 'src/app/components/ride-area/ride-area.actions';
import { selectRideAreas } from 'src/app/components/ride-area/ride-area.reducer';
import { AppState } from 'src/app/models/app-state';
import { RideAreaResource } from './ride-area-resource.service';

@Injectable({ providedIn: 'root' })
export class RideAreaService {
    rideAreas: RideArea[];

    private hasFetchedRideAreas = false;

    constructor(
        private rideAreaResource: RideAreaResource,
        private store: Store<AppState>
    ) {
        store
            .pipe(select(selectRideAreas))
            .subscribe((rideAreas) => (this.rideAreas = rideAreas));
    }

    getAllRideAreas$(): Observable<RideArea[]> {
        if (!this.hasFetchedRideAreas) {
            this.hasFetchedRideAreas = true;

            return this.rideAreaResource.getAllRideAreas().pipe(
                switchMap((rideAreas) => {
                    this.store.dispatch(new SetRideAreas(rideAreas));

                    return this.store.pipe(select(selectRideAreas));
                })
            );
        }

        return this.store.pipe(select(selectRideAreas));
    }

    getRideArea(id: string): Observable<RideArea> {
        const cachedRideArea = this.getCachedRideArea(id);
        if (cachedRideArea) {
            return of(cachedRideArea);
        }

        return this.rideAreaResource.getRideAreaById(id).pipe(
            tap((rideArea) => {
                this.store.dispatch(new UpdateRideArea(rideArea));
            })
        );
    }

    getCachedRideArea(id: string): RideArea | undefined {
        return find(this.rideAreas, { id });
    }
}
